import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";

import CollaboratorManagementModal from "./CollaboratorManagementModal";
import { WorkspaceUser } from "../../../common/types";
import { ConversationCollaborator } from "../services/collaboration";

const workspaceUsers: WorkspaceUser[] = [
  {
    user_id: "owner-1",
    email: "owner@example.com",
    role: "owner",
    status: "accepted",
  },
  {
    user_id: "collab-1",
    email: "alice@example.com",
    role: "member",
    status: "accepted",
  },
  {
    user_id: "collab-2",
    email: "bob@example.com",
    role: "member",
    status: "accepted",
  },
  {
    user_id: "collab-3",
    email: "charlie@example.com",
    role: "member",
    status: "accepted",
  },
  {
    user_id: "invitee-1",
    email: "invited@example.com",
    role: "member",
    status: "invited",
  },
];

const collaborators: ConversationCollaborator[] = [
  {
    user_id: "owner-1",
    display_name: "owner@example.com",
    email: "owner@example.com",
    role: "owner",
    added_at: "2026-04-25T10:00:00Z",
    added_by: null,
  },
  {
    user_id: "collab-1",
    display_name: "alice@example.com",
    email: "alice@example.com",
    role: "collaborator",
    added_at: "2026-04-25T10:05:00Z",
    added_by: "owner@example.com",
  },
];

describe("CollaboratorManagementModal", () => {
  it("filters the typeahead to accepted workspace members excluding owner and already-added collaborators", () => {
    render(
      <CollaboratorManagementModal
        open={true}
        workspaceUsers={workspaceUsers}
        collaborators={collaborators}
        onClose={jest.fn()}
        onAdd={jest.fn()}
        onRemove={jest.fn()}
      />,
    );

    fireEvent.change(screen.getByPlaceholderText("Search workspace members"), {
      target: { value: "e" },
    });

    expect(
      screen.queryByTestId("collaborator-option-owner-1"),
    ).not.toBeInTheDocument();
    expect(
      screen.queryByTestId("collaborator-option-collab-1"),
    ).not.toBeInTheDocument();
    expect(
      screen.getByTestId("collaborator-option-collab-3"),
    ).toBeInTheDocument();
    expect(
      screen.queryByTestId("collaborator-option-invitee-1"),
    ).not.toBeInTheDocument();
  });

  it("adds selected users as chips and removes them from the selected list", () => {
    render(
      <CollaboratorManagementModal
        open={true}
        workspaceUsers={workspaceUsers}
        collaborators={collaborators}
        onClose={jest.fn()}
        onAdd={jest.fn()}
        onRemove={jest.fn()}
      />,
    );

    fireEvent.click(screen.getByTestId("collaborator-option-collab-2"));

    expect(screen.getByText("bob@example.com")).toBeInTheDocument();
    expect(screen.getByRole("button", { name: "Add" })).toBeEnabled();

    fireEvent.click(
      screen.getByRole("button", { name: "Remove bob@example.com" }),
    );

    expect(
      screen.queryByRole("button", { name: "Remove bob@example.com" }),
    ).not.toBeInTheDocument();
  });
});
